import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {TransformerInterface} from "./transformerInterface";
import {CommandDTO} from "../domain/dtos/command.dto";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {RestoreEntityCommand} from "../commands/restore-entity.command";

/**
 * Serializes a RestoreEntityCommand into the backend command DTO (O2D-PRD-101).
 *
 * The frontend command carries the FULL soft-deleted entity as its in-memory payload so
 * command-send.listener (case 'restore') can republish `entity.changed` with the real
 * prototype (`entity.constructor`) and drive the type-scoped view refresh (G4). The backend
 * RestoreEntityCommand, however, expects `payload: { entityType, uid }` (RestoreEntityCommand.php).
 *
 * This dedicated transformer bridges that gap: `entityType` = the command's `mainEntityClass`
 * (the canonical snake_case key, e.g. 'issue' / 'knowledge_object'), `uid` = `mainEntityUid`.
 * It deliberately does NOT read the entity payload, so — unlike the generic command→DTO
 * fallback in TransformerHelper — it needs no proxified payload.
 */
@injectable()
@transformer({
    source: RestoreEntityCommand,
    target: `dto`
})
export class RestoreEntityCommandToDtoTransformer implements TransformerInterface<CommandDTO<DataTransferObject>, RestoreEntityCommand> {

    public async transform(command: RestoreEntityCommand): Promise<CommandDTO<DataTransferObject>> {
        return <CommandDTO<DataTransferObject>>{
            uid: command.uid,
            name: command.name,
            mainEntityClass: command.mainEntityClass,
            mainEntityUid: command.mainEntityUid,
            payload: {
                entityType: command.mainEntityClass,
                uid: command.mainEntityUid,
            },
        };
    }
}
